module.exports = __webpack_public_path__ + "img/助力医疗诊所高效运转.007dbe81.png";